import React from 'react';
import CountUp from 'react-countup';
import PropTypes from 'prop-types';

// Composant graphique pour afficher un Counter.
// Composant "dumb", fait juste afficher un count animé
// en fonction de props.data.
const Counter = props => {
  var { data } = props;
  if (typeof data === 'undefined' || data === null || isNaN(data)) {
    return <span className="counter-wrap">0</span>;
  }

  return (
    <CountUp
      className="counter-wrap"
      separator=" "
      decimal=","
      end={data}
      preserveValue
    />
  );
};

Counter.propTypes = {
  data: PropTypes.array,
};

export default Counter;
